import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Category from '../Category';
import Dialog from '../Dialog';
import FavoriteIcon from '../FavoriteIcon';
import Footer from '../Footer';
import Header from '../Header';
import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LoadingButton from '@mui/lab/LoadingButton';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const ManageAd = () => {
	async function getList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/ad/list/generating_image").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function uploadFile(file){
        setUploading(true)
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/ad/file/generating_image")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        // アップロード終了
                        setUploading(false)
                        document.getElementById("file").value = ""
                        getList().then(r=>{
                            if(r.result){
                                setList(r.data)
                            }
                        })
                    } else {
                        alert(r.errors)
                        setUploading(false)
                    }
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = (e) => {
            setProgressNow(0)
            setProgressLabel(0)
            setUploading(false)
            console.log(e)
            //dialog("エラー","通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            label = per + "%"

            setProgressNow(per)
            setProgressLabel(label)
        }
        let fd = new FormData()
        fd.append("file",file)
        req.send(fd)
        return req
    }
    const location = useLocation()
	const [list,setList] = useState([])
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState("")
    const [uploading,setUploading] = useState(false)

	useEffect(() => {
		document.querySelector("title").textContent = "広告管理 - アワートAI"
		getList().then(r=>{
			if(r.result){
				setList(r.data)
			}
		})
        console.log(uploading)
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container>
            <h3 style={{fontFamily:"Meiryo UI"}}>広告一覧</h3>
            <Table striped bordered hover style={{width:"100%"}}>
                <thead>
                    <tr><th>サムネイル</th><th>URL</th></tr>
                </thead>
                <tbody>
                {list.map((d,i) => {
                    if(i === 10) return ""
                    return (
                        <>
                            <tr><td style={{width:"150px",height:"150px"}}><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/ad/"+d.user_id+"/"+d.img_id+".webp"} width={150} style={{objectFit:"cover",width:"100%",height:"100%"}} /></td><td><Link to={d.url} target='_blank'>{d.url}</Link></td></tr>
                        </>
                    )
                })}
                </tbody>
            </Table>
            <LoadingButton
                loading={uploading}
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                >
                ZIPファイル登録
                <VisuallyHiddenInput id='file' type="file" onChange={(e) => {
                    uploadFile(e.target.files[0])
                }} />
            </LoadingButton>
            <br /><br />
            ファイルを登録すると登録済みの情報は削除されます。<br /><br />
            ファイル構成<br />
            ■ file.zip<br />
            ├ images<br />
            │ ├ xxxxxxxxxx.webp<br />
            │ ├ xxxxxxxxxx.webp<br />
            │ └ xxxxxxxxxx.webp<br />
            └  info.csv<br /><br />

            ■ info.csv<br />
            <Table striped bordered hover style={{width:"100%"}}>
                <thead>
                    <tr><th>File</th><th>URL</th></tr>
                </thead>
                <tbody>
                    <tr><td>xxxxxxxxxx.webp</td><td>https://example.com/11111</td></tr>
                    <tr><td>xxxxxxxxxx.webp</td><td>https://example.com/22222</td></tr>
                    <tr><td>xxxxxxxxxx.webp</td><td>https://example.com/33333</td></tr>
                </tbody>
            </Table>
        </Container>
        <Footer />
    </div>
    )
}

export default ManageAd;
